import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/fr';

Vue.filter('dateFormat', (value, format = 'DD/MM/YYYY') => {
    if (!value) return '';
    return moment(value).format(format);
});

Vue.filter('currency', (amount, locale = 'fr-FR', currency = 'XOF') => {
    if (amount === null || amount === undefined || amount === '') {
        return '0';
    }

    const parsedAmount = typeof amount === 'number' ? amount : parseFloat(amount);
    if (isNaN(parsedAmount)) {
        return '-';
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
    }).format(parsedAmount);
});

